import * as RadixToast from '@radix-ui/react-toast';
import classNames from 'classnames';
import React from 'react';
import { Icon } from '../../../visual-components/icon/icon';
import { IconVariant } from '../../../visual-components/icon/icon-data';
import { Link, LinkButton } from '../../../visual-components/link/link';
import { Typography } from '../../../visual-components/typography/typography';
import { notNil } from '../../../core/helpers/is-nil';
import { NotificationItem } from '../types';
import styles from './toast.module.scss';

const TOAST_DURATION_MS = 4000;

type Props = {
  text: string;
  icon?: IconVariant;
  action?: NotificationItem['action'];
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const Toast: React.FC<Props> = ({ text, icon, action, open, onOpenChange }) => {
  const hasIcon = notNil(icon);
  const hasActionLink = notNil(action?.type === 'link');
  const hasActionButton = notNil(action?.type === 'button');
  const hasAction = hasActionLink || hasActionButton;

  const closeNotification = () => onOpenChange(false);

  return (
    <>
      <RadixToast.Root
        className={classNames(styles.root)}
        duration={TOAST_DURATION_MS}
        open={open}
        type="background"
        onOpenChange={onOpenChange}
      >
        <RadixToast.Description className={classNames(styles.description)}>
          <div className={styles.iconTextContainer}>
            {hasIcon ? <Icon className={classNames(styles.icon)} size="24" variant={icon} /> : null}
            <Typography className={classNames({ [styles.withButton]: hasAction })} variant="maintext">
              {text}
            </Typography>
          </div>
          <div className={styles.actionContainer}>
            {action?.type === 'link' ? (
              <Link
                className={classNames(styles.action)}
                to={action.to}
                onClick={() => {
                  closeNotification();
                }}
              >
                {action.text}
              </Link>
            ) : null}
            {action?.type === 'button' ? (
              <LinkButton
                className={classNames(styles.action)}
                onClick={() => {
                  action.onClick();
                  closeNotification();
                }}
              >
                {action.text}
              </LinkButton>
            ) : null}
          </div>
        </RadixToast.Description>
      </RadixToast.Root>
    </>
  );
};
